module.exports = __webpack_public_path__ + "static/img/Max-Plath.35639ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Max-Plath.jpg
// module id = siUd
// module chunks = 0